module.exports = __webpack_public_path__ + "static/media/SESAME.dedcc02b.png";